import BioFutureHero from "./bio-future/BioFutureHero";
import BioFutureTimeline from "./bio-future/BioFutureTimeline";
import BioFutureBlocks from "./bio-future/BioFutureBlocks";
import BioFutureTextBlock from "./bio-future/BioFutureTextBlock";

class PageBioFuture {
    constructor() {
        const mainHero = document.getElementById("bio-future-hero-topo-pattern-wrapper");
        const timelineEl = document.getElementById("bio-future-timeline");
        const blocksGrid = document.getElementById('bh-grid-animation')
        const textBlock = document.getElementById('bio-future-text-block');


        if (mainHero) {
            const hero = new BioFutureHero(mainHero);
        }

        if (timelineEl) {
            const timeline = new BioFutureTimeline(timelineEl);
        }

        if (blocksGrid) {
            const blocks = new BioFutureBlocks(blocksGrid);
        }

        if(textBlock) {
            const text = new BioFutureTextBlock(textBlock);
        }


    }
}

export default PageBioFuture
